
import { QRCodeSVG as QRCode } from 'qrcode.react';

const WeChatBarcode = ({id='xys123',paid = false})=>{


    return (
        <>
            <div style={{ background: 'white', padding: '16px' }} className='row'>
                <QRCode 
                    value ='hello' 
                    size={128} 
                    level="H"
                    fgColor= { paid ? "red": "" } 
                    className='mx-auto'
                />
            </div>
            <div className ='row'>
                <span className='mx-auto'>ID:{id}</span>
            </div>
        </>
       
        
    );
}

export default WeChatBarcode;